export const VERSION_AREAS = {
  'Seguridad':          { label: 'Seguridad',          icon: 'Shield',    className: 'border-violet-300 text-violet-700' },
  'Experiencia de uso': { label: 'Experiencia de uso', icon: 'Sparkles',  className: 'border-pink-300 text-pink-700' },
  'Rendimiento':        { label: 'Rendimiento',        icon: 'Gauge',     className: 'border-cyan-300 text-cyan-700' },
  'Reportes y datos':   { label: 'Reportes y datos',   icon: 'BarChart3', className: 'border-teal-300 text-teal-700' },
  'Confiabilidad':      { label: 'Confiabilidad',      icon: 'Handshake', className: 'border-indigo-300 text-indigo-700' },
  'Calidad interna':    { label: 'Calidad interna',    icon: 'Wrench',    className: 'border-slate-300 text-slate-600' },
} as const;

export type VersionArea = keyof typeof VERSION_AREAS;
